import { Routes } from '@angular/router';
import { AbTestService } from './shared/abtest';
import { inject } from '@angular/core';
import { ParametersGuard } from './shared/resolvers/parameters-guard';

export const bookingLoader = () => import('./pages/booking/booking.component').then(m => m.BookingComponent);

export const routes: Routes = [
  {
    // redirect / to start page
    path: '',
    pathMatch: 'full',
    data: { skipRouteLocalization: true },
    redirectTo: '/SKIHIREENTRY'
  },
  {
    // redirect /{lang} to search startpage
    path: '',
    pathMatch: 'full',
    redirectTo: '/SKIHIREENTRY'
  },
  {
    path: 'STATIC.SWISSPASS',
    loadComponent: () =>
      import('./pages/static/swisspass/swisspass-page/swisspass-page.component').then(
        c => c.SwisspasPageComponent
      )
  },
  {
    path: 'STATIC.TERMSANDCONDITIONS',
    loadChildren: () => import('./pages/text-render-page/text-render-page.routes').then(mod => mod.routes)
  },
  {
    path: 'STATIC.HOWTO',
    loadComponent: () => import('./pages/static/videos/videos.component').then(c => c.VideosComponent)
  },
  {
    path: 'STATIC.PRIVACYPOLICY',
    loadComponent: () =>
      import('./pages/text-render-page/text-render-page.component').then(c => c.TextRenderPageComponent),
    data: {
      textResource: 'pp',
      translationKey: 'privacy'
    }
  },
  {
    path: 'STATIC.HELP',
    pathMatch: 'full',
    loadComponent: () => import('./pages/static/help-page/help-page.component').then(c => c.HelpPageComponent)
  },
  {
    path: 'partner-/:partner/STATIC.HELP',
    loadComponent: () => import('./pages/static/help-page/help-page.component').then(c => c.HelpPageComponent)
  },
  {
    path: 'faq',
    pathMatch: 'full',
    loadComponent: () => import('./pages/static/faq/faq.component').then(c => c.FaqComponent)
  },
  {
    path: 'partner-/:partner/faq',
    loadComponent: () => import('./pages/static/faq/faq.component').then(c => c.FaqComponent)
  },
  {
    path: 'STATIC.IMPRINT',
    loadComponent: () =>
      import('./pages/text-render-page/text-render-page.component').then(c => c.TextRenderPageComponent),
    data: {
      textResource: 'ip',
      translationKey: 'imprint'
    }
  },
  {
    // https://www.alpy.com/en/ski-rental/booking?bookingReference=asdfasfasdfsafsf
    path: 'SKIHIREENTRY/booking',
    redirectTo: () => 'payment/processing',
    pathMatch: 'full'
  },
  {
    // https://www.alpy.com/en/ski-rental/partner-hervis/booking?asdfasfasdfsafsf
    path: 'SKIHIREENTRY/partner-/:partner/booking',
    redirectTo: ({ params }) => `payment/partner-${params.partner}/processing`,
    pathMatch: 'full'
  },
  {
    path: 'STATIC.ABOUTUS',
    loadComponent: () => import('./pages/about-us/about-us-page.component').then(c => c.AboutUsPageComponent)
  },
  {
    path: 'my-account',
    loadChildren: () => import('./pages/my-account/my-account.routes').then(r => r.routes)
  },
  {
    // https://www.alpy.com/de/partner
    path: 'partner',
    loadChildren: () => import('./pages/become-partner/become-partner.routes').then(r => r.ROUTES)
  },
  {
    // https://www.alpy.com/en/ratings/rateshop/6oBhRnkM
    path: 'ratings/rateshop/:cryptedKey',
    loadComponent: () =>
      import('./pages/shop-rating/components/shop-rating-page.component').then(c => c.ShopRatingPageComponent)
  },
  {
    path: 'CHECKOUT.PAYMENT/CHECKOUT.CHECKOUT',
    loadChildren: () => import('./pages/check-out-abx/check-out-page.routes').then(r => r.routes),
    canMatch: [() => inject(AbTestService).getVersion('paymentPosition') !== 'v1']
  },

  {
    path: 'CHECKOUT.PAYMENT/CHECKOUT.CHECKOUT',
    loadChildren: () => import('./pages/check-out/check-out-page.routes').then(r => r.routes)
  },
  {
    path: 'referrer',
    loadComponent: () =>
      import('./pages/mention-me-landing/mention-me-landing.component').then(r => r.MentionMeLandingComponent)
  },
  {
    path: 'CHECKOUT.PAYMENT/partner-/:partner/CHECKOUT.CHECKOUT',
    loadChildren: () => import('./pages/check-out-abx/check-out-page.routes').then(r => r.routes),
    canMatch: [() => inject(AbTestService).getVersion('paymentPosition') !== 'v1']
  },
  {
    path: 'CHECKOUT.PAYMENT/partner-/:partner/CHECKOUT.CHECKOUT',
    loadChildren: () => import('./pages/check-out/check-out-page.routes').then(r => r.routes)
  },
  {
    // all search results or new search page
    path: 'SKIHIREENTRY/SKIHIRE.SEARCH',
    redirectTo: '/SKIHIREENTRY'
  },
  {
    // the page for group bookings and offers
    path: 'SKIHIREENTRY/SKIHIRE.GROUPS',
    loadChildren: () => import('./pages/groups-booking/groups-booking.routes').then(r => r.routes)
  },
  {
    path: 'SKIHIREENTRY/STATIC.ADDITIONALOFFERS',
    loadComponent: () =>
      import('./pages/static/additional-offers-page/additional-offers-page.component').then(
        c => c.AdditionalOffersPageComponent
      )
  },
  {
    path: 'SKIHIREENTRY/poi/:slug',
    loadComponent: () => import('./pages/poi/poi.component').then(r => r.PoiComponent),
    data: { landingPage: true }
  },
  {
    // https://www.alpy.com/en/ski-rental/products?asdfasfasdfsafsf
    path: 'SKIHIREENTRY/PRODUCTS',
    children: [],
    canActivate: [ParametersGuard]
  },
  {
    // https://www.alpy.com/de/skiverleih/partner-sport-brugger/products?asdfasfasdfsafsf
    path: 'SKIHIREENTRY/partner-/:partner/PRODUCTS',
    children: [],
    canActivate: [ParametersGuard]
  },
  {
    // 'notnagel' solution for wintersport.nl shop links
    // angular 'redirectTo' doesn't keep query parameters so we do the redirect with a routerGuardFn
    // as long as the guard returns an URLTree, it will redirect to the given route.
    path: 'SKIHIREENTRY/parameters/:shopId',
    children: [],
    canActivate: [ParametersGuard]
  },
  {
    // 'notnagel' solution for wintersport.nl shop links
    // angular 'redirectTo' doesn't keep query parameters so we do the redirect with a routerGuardFn
    // as long as the guard returns an URLTree, it will redirect to the given route.
    path: 'SKIHIREENTRY/partner-/:partner/parameters/:shopId',
    children: [],
    canActivate: [ParametersGuard]
  },

  // New Partner Zoomin
  {
    // zoomin for 'all' countries
    path: 'SKIHIREENTRY/partner-/:partner/COUNTRIES',
    data: { landingPage: true },
    loadComponent: () =>
      import('./pages/partner-zoom-in/partner-shop-zoom-in/partner-shop-zoom-in.component').then(
        m => m.PartnerShopZoomInComponent
      )
  },
  {
    // zoomin for a specific country
    path: 'SKIHIREENTRY/partner-/:partner/:country',
    data: { landingPage: true },
    loadComponent: () =>
      import('./pages/partner-zoom-in/partner-shop-zoom-in/partner-shop-zoom-in.component').then(
        m => m.PartnerShopZoomInComponent
      )
  },
  {
    // zoomin for a province in a country
    path: 'SKIHIREENTRY/partner-/:partner/:country/:province',
    data: { landingPage: true },
    loadComponent: () =>
      import('./pages/partner-zoom-in/partner-shop-zoom-in/partner-shop-zoom-in.component').then(
        m => m.PartnerShopZoomInComponent
      )
  },
  // New Partner Zoomin end

  {
    path: 'SKIHIREENTRY/partner-/:partner/:country/:province/:town/:shop',
    loadChildren: () => import('./pages/partner-shop/partner-shop.routes').then(m => m.ROUTES)
  },
  {
    path: 'SKIHIREENTRY/:country/:province/:town',
    loadChildren: () =>
      import('./pages/saleslocation/shop-list/shop-list.routes').then(r => r.SHOPLIST_ROUTES)
  },
  {
    path: 'SKIHIREENTRY/partner-/:partner',
    loadChildren: () =>
      import('./pages/partner-shop-list/partner-shop-list.routes').then(r => r.PARTNER_SHOPLIST_ROUTES)
  },
  {
    path: 'SKIHIREENTRY/partner-/:partner/:country/:province/:town',
    loadChildren: () =>
      import('./pages/partner-shop-list/partner-shop-list.routes').then(r => r.PARTNER_SHOPLIST_ROUTES)
  },
  {
    path: 'SKIHIREENTRY/:country/:province/:town/:shop',
    loadChildren: () => import('./pages/shop/shop.routes').then(m => m.ROUTES)
  },
  {
    path: 'SKIHIREENTRY/:country/:province/:town/:shop_identifier/PRODUCTS',
    loadChildren: () => import('./pages/product-selection/product-selection.routes').then(mod => mod.routes)
  },
  {
    path: 'SKIHIREENTRY/partner-/:partner/:country/:province/:town/:shop_identifier/PRODUCTS',
    loadChildren: () => import('./pages/product-selection/product-selection.routes').then(mod => mod.routes)
  },
  {
    path: 'SKIHIREENTRY',
    data: { landingPage: true },
    loadComponent: () => import('./pages/start/start/start.component').then(c => c.StartComponent)
  },
  {
    path: 'SKISCHOOLENTRY',
    loadComponent: () => import('./pages/skischool/start/start.component').then(m => m.StartComponent)
  },
  {
    // zoomin for a specific country
    path: 'SKIHIREENTRY/:country',
    loadComponent: () =>
      import('./pages/zoom-in/shop-zoom-in/shop-zoom-in.component').then(m => m.ShopZoomInComponent),
    data: { landingPage: true }
  },
  {
    // zoomin for a province in a country
    path: 'SKIHIREENTRY/:country/:province',
    loadComponent: () =>
      import('./pages/zoom-in/shop-zoom-in/shop-zoom-in.component').then(m => m.ShopZoomInComponent),
    data: { landingPage: true }
  },
  {
    // https://www.alpy.com/de/payment/(processing|confirmation)?bookingReference=1231231
    path: 'payment/:state',
    loadComponent: bookingLoader
  },
  {
    // https://www.alpy.com/de/payment/partner-sport-brugger/(processing|confirmation)?bookingReference=1231231
    path: 'payment/partner-/:partner/:state',
    loadComponent: bookingLoader
  },
  {
    path: 'not-found',
    loadComponent: () => import('./pages/error/error404/error404.component').then(c => c.Error404Component)
  },
  {
    path: '**',
    redirectTo: '/not-found'
  }
  // !!! NO ROUTES AFTER THE FALLBACK ROUTE => ( path: '**' )
];
